import type { CompositePrice, Price } from '@epilot/journey-logic-commons'
import {
  getPriceType,
  hasTieredPricingModel,
  isCompositePrice
} from '@epilot/journey-logic-commons'
import { PricingModel } from '@epilot/pricing'
import type { ComponentType } from 'react'

import { Typography } from '../../../../components'
import classes from '../../styles/PriceTierDetails.module.scss'
import type { ComponentMappingDataGraduatedProps } from '../../types'
import { useTileContext } from '../../utils/tile-context-utils'

export const PriceTierDetails = ({
  price,
  ComponentMappingDataGraduated,
  unitAmount,
  amountTotal
}: {
  price: Price | CompositePrice
  ComponentMappingDataGraduated: ComponentType<ComponentMappingDataGraduatedProps>
  unitAmount?: string
  amountTotal?: string
}) => {
  const { actions, tileState, config } = useTileContext()

  if (isCompositePrice(price) || !price) return null

  if (!hasTieredPricingModel(price)) return null

  if (price.pricing_model === PricingModel.tieredGraduated) {
    return (
      <ComponentMappingDataGraduated
        amountTotal={amountTotal}
        className={classes.priceComponent}
        displayInOneLine
        displayUnitaryAverage={
          config.generalTileConfiguration.displayUnitaryAverage
        }
        isShownOnProductCard={true}
        price={price._price}
        quantity={tileState.quantity}
        showPriceDescription
        showTrailingDecimalZeros={
          config.generalTileConfiguration.showTrailingDecimalZeros
        }
        t={actions.t}
        unitAmount={unitAmount}
        useNewDesign={true}
      />
    )
  }

  const billingPeriod =
    !price._price.variable_price &&
    price._price.type !== 'one_time' &&
    getPriceType(price._price.type, price._price.billing_period)

  const description = price.description

  return (
    <>
      <Typography className={classes.text} variant="secondary">
        {description && <span>{description}</span>}
      </Typography>
      <Typography className={classes.price}>
        <span>{amountTotal}</span>
        {billingPeriod && (
          <span>{actions.t(billingPeriod).toLocaleLowerCase()}</span>
        )}
      </Typography>
    </>
  )
}
